"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BackgroundColorProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BackgroundColorContext = /*#__PURE__*/_react["default"].createContext(null);

var getColorType = function getColorType(hexColor) {
  try {
    if (hexColor) {
      var hslColor = (0, _color["default"])(hexColor).hsl();
      var lightnessColor = hslColor.color[2];
      return lightnessColor <= 30 ? "dark" : "light";
    }
  } catch (e) {
    return "light";
  }
};

var BackgroundColorProvider = function BackgroundColorProvider(_ref) {
  var color = _ref.color,
      children = _ref.children;
  var colorType = (0, _react.useMemo)(function () {
    return getColorType(color);
  }, [color]);
  return /*#__PURE__*/_react["default"].createElement(BackgroundColorContext.Provider, {
    value: colorType
  }, children);
};

exports.BackgroundColorProvider = BackgroundColorProvider;
var _default = BackgroundColorContext;
exports["default"] = _default;